import BaseCheckbox from '../BaseCheckbox';

export type CheckboxProps = {
    checked?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

const Checkbox = ({ checked, onChange }: CheckboxProps) => {
    return <BaseCheckbox checked={checked} onChange={onChange} />;
};

export default Checkbox;
